module.exports = __webpack_public_path__ + "img/5.85ffeba5.png";